import { render, staticRenderFns } from "./UserPaymentMethods.vue?vue&type=template&id=4c8aeb5a"
import script from "./UserPaymentMethods.vue?vue&type=script&lang=js"
export * from "./UserPaymentMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports